import { Tabs, Tab } from '@mui/material';
import styled from '@emotion/styled';
import { BASIC_BORDER_RADIUS } from '../../../themes/tokens';

export const StyledTabs = styled(Tabs)`
  background-color: #426245;
  flex: 1;
  display: flex;
  align-items: stretch;
  box-shadow: 0 0 3px #223223ff;
  border-radius: ${BASIC_BORDER_RADIUS};

  .MuiTabs-indicator {
    background-color: white;
    height: 3px;
  }

  .MuiTabs-flexContainer {
    height: 100%;
  }
`;

export const StyledTab = styled(Tab)`
  color: white;
  flex: 1;
  font-weight: 500;
  letter-spacing: 1px;

  &.Mui-selected {
    color: white;
  }
`;
